








































import Vue from 'vue'
import Component from "vue-class-component"
import { Toast, Dialog } from "vant"
import moduleStore from './store/voiceClone'
import Cookies from 'js-cookie'
import PayCard from '../../components/pay/pay.vue'
import { throttling, toast } from '@/utils/util'

interface VoiceItem {
  type: string  // 类型 
  id: number  // id
  name: string
  gender: string
  docsType: string
  price: number
  status: number
  customizeType: string
  update: string
  headerImage: string


}
interface KeyWordItem {
  text: string
  key: string
}


Component.registerHooks([
  'beforeRouteEnter'
]);
@Component({
  components: {
    PayCard
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class vipWechatPay extends Vue {
  payType: number = 0;

  // 升级手机号填写错误
  isPhoneErrorVisible: boolean = false
  // 关键词列表
  keyList: KeyWordItem[] = [
    { text: '声音名称', key: 'name' },
    { text: '声音性别', key: 'gender' },
    { text: '声音头像', key: 'headerImage' },
    { text: '录制台词', key: 'docsType' },
    { text: '模型类型', key: 'customizeType' },
    { text: '制作费用', key: 'price' },
  ]
  voiceInfo: any = {}
  taskId: string = ''
  //升级信息
  voiceItem: VoiceItem = {
    type: '',
    id: 1,
    name: '',
    gender: '',
    docsType: '',
    price: 0,
    customizeType: '',
    status: 0,
    update: '2020.12.21 12:00',
    headerImage: 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-03-20-6262747787105451550.png'
  }

  transformSpeaker(speakerItem) {
    return {
      storeId: speakerItem.storeId,
      speakerId: speakerItem.speakerId,
      name: speakerItem.packageName || speakerItem.name,
      imgUrl: speakerItem.headerImage,
      isSelected: false,
    };
  }

  async mounted() {
    this.getmyOrderInfo()
  }
  payVoice() {
    this.$router.push({ name: 'voicePay' })
  }
  viewRecord() {
    this.$router.push({ name: 'voiceRecord' })
  }
  /**
   * 路由前置守卫
   */
  created() {
    // 清除原本的 cookies
    this.taskId = this.$getUrlKeyWord('taskId')

  }
  //获取订单信息请求
  getmyOrderInfo() {
    this.$http('getOrderInfo', {
      taskId: this.taskId
    }).then((res: any) => {
      if (res.code == 200) {
        this.voiceItem = res.data
      } else {
        toast(res.msg)
      }
    })
  }
  // 购买成功页面路径
  get successRoute() {
    return {
      path: "/voicePaySuccess",
      query: {
        price: this.voiceItem.price/100 +'',
        type: this.voiceItem.type

      },
    };
  }
  /**
   * 调起下单接口
   */
  buySuperVip(list?) {
    // 解构赋值
    const { phone, priceActiveId: packageId } = this.voiceInfo
    // 从本地缓存获取渠道 code
    const channelCode = Cookies.get('CHANNEL_CODE') || ''
    // 初始化手机提示状态
    this.isPhoneErrorVisible = false
    // 设置接口参数
    let params: any = {}
    let payComponent: any = this.$refs.payCard
    // 判断是否符合设置的套餐
    params = {
      taskId: this.taskId
    }
    let httpUrl = "payClone"

    // 调用后端的下单接口
    this.$http(httpUrl, {
      ...params
    })
      .then(res => {
        const { code, data } = res
        // data ===现在的payParams
        if (code === 200) {
          // 调起支付
          payComponent.aliPay({ ...data, from: 'voiceClone', isVoice: '' }, this.successRoute)

        } else {
          Toast({
            message: res.message,
            icon: "none",
            duration: 3000,
            position: 'top'
          })
        }
      })
      .catch(error => {
        toast("出错了，请重新打开页面进行购买～", "top");
        console.error(error)
      })
  }

}
